export default class GeoReference {
  type;

  constructor(type) {
    this.type = type;
  }
}
